"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractableOptionType = void 0;
var InteractableOptionType;
(function (InteractableOptionType) {
    InteractableOptionType["Dialogue"] = "dialogue";
    /**
     * For when an item can be picked up
     */
    InteractableOptionType["ItemPickup"] = "itemPickup";
})(InteractableOptionType || (exports.InteractableOptionType = InteractableOptionType = {}));
